var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.layout == 'iptv')?_c('iptv-webplayer-layout'):_c('default-webplayer-layout')
}
var staticRenderFns = []

export { render, staticRenderFns }